import { useState } from "react";

import { Box, IconButton, Stack, Typography } from "@mui/material";
import EditSquareIcon from "@mui/icons-material/EditSquare";

import useLocalization from "../../hooks/useLocalization";

import MatrixItemModal from "../modals/MatrixItemModal";
import InfoBox from "../layout/InfoBox";

const MatrixItem = ({ surveyId, matrixItems, onChange }) => {
  const { getLabel, getMessage } = useLocalization();

  const [openModal, setOpenModal] = useState(false);

  const handleSave = (newValue) => {
    setOpenModal(false);
    onChange(newValue);
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        gap={1}
      >
        <InfoBox
          label={getLabel("matrixItems")}
          sx={{ backgroundColor: "#f0f0f0", color: "#777" }}
        >
          {Array.isArray(matrixItems) && matrixItems.length > 0 ? (
            <Stack>
              {matrixItems.map((item) => (
                <Typography sx={{ fontSize: "10px" }}>{item.name}</Typography>
              ))}
            </Stack>
          ) : (
            <Typography>{getMessage("notSet")}</Typography>
          )}
        </InfoBox>

        <IconButton onClick={() => setOpenModal(true)}>
          <EditSquareIcon />
        </IconButton>
      </Box>

      <MatrixItemModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onSave={handleSave}
        matrixItems={matrixItems}
        surveyId={surveyId}
      />
    </>
  );
};

export default MatrixItem;
